var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationtypeServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_di_10519_44060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 24.668C44 35.7137 27.017 51.3346 24 51.3346C20.983 51.3346 4 35.7137 4 24.668C4 13.6223 12.9543 4.66797 24 4.66797C35.0457 4.66797 44 13.6223 44 24.668Z",
    fill: "#D09386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24Z",
    fill: "#F7D5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6357 18.9586C26.8064 18.7883 27.0697 18.7666 27.2637 18.8942L27.3428 18.9586L29.0859 20.6989L29.1504 20.777C29.2786 20.9708 29.2573 21.2349 29.0869 21.4059C28.9164 21.5765 28.653 21.5979 28.459 21.4704L28.3799 21.4059L26.6357 19.6657L26.5723 19.5876C26.4439 19.3936 26.4651 19.1297 26.6357 18.9586Z",
    fill: "#8F4838"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1191 16.0016C27.5499 16.0206 27.9552 16.2062 28.2529 16.5172L31.4814 19.736C31.7937 20.0332 31.979 20.4391 31.998 20.8708C32.0151 21.2574 31.8974 21.6358 31.668 21.943L31.5625 22.07C31.5548 22.0784 31.5471 22.0873 31.5391 22.0954L29.7646 23.8668C29.5782 24.0528 29.3072 24.1273 29.0518 24.0631L27.0322 23.5553L24.6709 25.9108L26.3584 27.5944C26.6158 27.8516 26.6413 28.2496 26.4424 28.5543C26.2536 28.8437 26.0053 29.1063 25.7686 29.3551C25.344 29.8014 24.7175 30.3751 23.9131 30.8737C22.3382 31.8497 20.062 32.5425 17.3574 31.4274C17.2542 31.3848 17.1965 31.3601 17.0947 31.3141C17.0073 31.2746 16.9358 31.2207 16.8672 31.1549C16.7901 31.081 16.7317 31.0036 16.6875 30.9069C15.403 28.0951 16.1191 25.7219 17.1289 24.0993C17.6286 23.2965 18.2033 22.6713 18.6504 22.2477C18.9047 22.0067 19.1724 21.7851 19.4521 21.5749C19.7421 21.3569 20.1532 21.403 20.4102 21.6588L22.1299 23.3747L24.4902 21.0172L23.959 18.9069C23.8945 18.6508 23.9703 18.3796 24.1572 18.193L25.8945 16.4586L25.9189 16.4352C26.2459 16.1378 26.6778 15.9822 27.1191 16.0016ZM22.6611 24.9655C22.3684 25.2578 21.8934 25.2586 21.6006 24.9665L19.8311 23.1999C19.7839 23.2423 19.7333 23.2876 19.6816 23.3366C19.2997 23.6985 18.8168 24.2263 18.4023 24.8922C17.6129 26.1608 17.0785 27.9106 17.9531 30.0465C20.0954 30.9202 21.8502 30.3865 23.1221 29.5983C23.7897 29.1845 24.319 28.7021 24.6816 28.3209C24.7299 28.2702 24.7735 28.2199 24.8154 28.1735L23.6094 26.9704L22.7168 27.862C22.4217 28.1562 22.035 28.338 21.624 28.3786L21.4473 28.3874C20.9714 28.3873 20.5139 28.1981 20.1768 27.862C20.0101 27.6956 19.8775 27.4974 19.7871 27.2799C19.6966 27.062 19.6495 26.8284 19.6494 26.5924C19.6494 26.3564 19.6965 26.122 19.7871 25.904C19.8777 25.6861 20.0106 25.4884 20.1777 25.3219C20.4712 25.0297 20.946 25.0305 21.2383 25.3239C21.5304 25.6173 21.5296 26.0921 21.2363 26.3844C21.2089 26.4118 21.1867 26.4446 21.1719 26.4801C21.1572 26.5156 21.1494 26.5541 21.1494 26.5924C21.1495 26.6308 21.1571 26.6693 21.1719 26.7047C21.1793 26.7225 21.1885 26.7396 21.1992 26.7555L21.2363 26.7995L21.2812 26.8366C21.3298 26.869 21.3877 26.8873 21.4473 26.8874L21.5059 26.8815C21.5629 26.8701 21.6156 26.8417 21.6572 26.8004L25.7412 22.7252L25.3213 22.3063L22.6611 24.9655ZM27.0527 17.4997C27.0085 17.4979 26.9656 17.5133 26.9326 17.5417L25.5176 18.9538L25.998 20.862L27.1855 22.0475L29.0059 22.5045L30.4551 21.0573C30.4852 21.024 30.5019 20.9813 30.5 20.9372C30.499 20.9148 30.4937 20.8927 30.4844 20.8727L30.4453 20.819C30.4376 20.8119 30.4293 20.8049 30.4219 20.7975L27.1953 17.5778C27.1879 17.5704 27.18 17.563 27.1728 17.5553C27.1422 17.5221 27.0987 17.5017 27.0527 17.4997Z",
    fill: "#8F4838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_10519_44060",
    x: -2,
    y: -1,
    width: 52,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.152941 0 0 0 0 0.0862745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10519_44060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10519_44060",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.152941 0 0 0 0 0.0862745 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_10519_44060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationtypeServices);
export default __webpack_public_path__ + "static/media/organizationtype-services.284d35ead69dd3f1638daf2eb3993547.svg";
export { ForwardRef as ReactComponent };